import { TermType } from '../builders/term_type_builder';
import { ITransferTermTypesDatasource } from '../datasources/transfer_term_types_datasource';

export interface ITermTypeNameService {
  (termTypeNK: string, defaultValue: string): string;
}

angular
  .module('capability-ng-transfer')
  .service('ngTermTypeNameService', (ngTransferTermTypesDatasource: ITransferTermTypesDatasource) => {
    return (termTypeNK: string, defaultValue: string = '') => {
      const termType: TermType = _.find(ngTransferTermTypesDatasource.read(), (item) => item.nk === termTypeNK);
      return !!termType ? termType.name : defaultValue;
    };
  });



// WEBPACK FOOTER //
// ./app/lib/transfer/services/term_type_name_service.ts